import React from "react";
import { useNavigate } from 'react-router-dom';
// import './BrowserFooter.scss';
import styles from  './BrowserFooter.module.scss';
import Dropdown from "@components/Dropdown";

import {ReactComponent as Arrow} from "img/arrow-right.svg";
import {ReactComponent as House} from "img/icon_house.svg";
import { useBrowserPage } from "../useBrowserPage";

interface BrowserFooterProps {
  totalItems: number;
  currentPage: number;
  totalPages: number;
}

const BrowserFooter: React.FC<BrowserFooterProps> = ({
  totalItems,
  currentPage,
  totalPages,
}) => {
  const navigate = useNavigate();
  const {
    StudyViewState,
    updatePagination
  } = useBrowserPage();

  const dropdownOptions = [
    { value: "20", label: "20" },
    { value: "25", label: "25" },
    { value: "30", label: "30" },
  ];

  const handleDropdownChange = (value: string) => {
    updatePagination({ perPage: Number(value) });
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      updatePagination({ currentPage: currentPage - 1 });
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      updatePagination({ currentPage: currentPage + 1 });
    }
  };

  return (
    <div className={styles.content}>
      <div className={styles.footerLeft}>
        <div className={styles.itemContainer}>
          <span className={styles.items}>
            {totalItems} items
          </span>
        </div>
        <div className={styles.pageContainer}>
          <div className={styles.pageInput}>

            <Dropdown
              id="items-per-page"
              placeholder="20"
              options={dropdownOptions}
              value={String(StudyViewState.perPage)}
              onChange={handleDropdownChange}
              position="top"
              className="dropdown-gap"
            />
            <span className={styles.pageNumber}>Page</span>
          </div>
        </div>
      </div>
      <div className={styles.footerRight}>
        <div
          className={styles.homeContainer}
          onClick={() => updatePagination({ currentPage: 1 })}
        >
          <span className={styles.home}>
            <House/>
          </span>
        </div>
        <span className={styles.pageInfoContainer}>
          {StudyViewState.currentPage} / {totalPages}
        </span>
        <div className={styles.previousContainer}>
          <div className={styles.previous}>
            <Arrow
              className={`${currentPage === 1 ? styles.disabled : ""}`}
              // className={`reverse-arrow no-padding ${currentPage === 1 ? "disabled" : ""}`}
              onClick={goToPrevPage}
              />
            </div>
        </div>
        <div className={styles.nextContainer}>
          <Arrow
            onClick={goToNextPage}
            className={`${currentPage === totalPages ? styles.disabled : ""}`}
            // className={`no-padding ${currentPage === totalPages ? "disabled" : ""}`}
            />
        </div>
      </div>
    </div>
  );
};

export default BrowserFooter;
